export const extractVariables = (content: string): string[] => {
  const variables = content?.match(/{[^}]+}/g);
  if (variables) {
    return Array.from(new Set(variables));
  }
  return [];
};
